import { AvailableYears } from '../types';
import * as S from './style';

interface Props {
  currentYear: AvailableYears;
  onClick?: (year: AvailableYears) => void;
}

const YEARS: AvailableYears[] = [1, 3, 5];

export default function ButtonGroup({ currentYear, onClick }: Props) {
  const handleClick = (year: AvailableYears) => {
    if (onClick) {
      onClick(year);
    }
  };

  return (
    <S.Wrapper>
      {YEARS.map((year) => (
        <S.Button
          active={currentYear === year}
          year={currentYear}
          key={`employee-chart-button-${year}`}
          data-attribute-id='company__personnel__filter__click'
          data-year={`${year}년`}
          onClick={() => handleClick(year)}>
          {`${year}년`}
        </S.Button>
      ))}
    </S.Wrapper>
  );
}
